define('entities/admin/generic_email_domains',[
  'app',
  'jquery',
  'underscore',
  'backbone',
  'settings',
  'backboneRelational'
], function (
  App,
  $,
  _,
  Backbone,
  Settings
) {
  'use strict';

  var app;
  if (Backbone.Relational.store._modelScopes && Backbone.Relational.store._modelScopes.length > 0) {
    app = { ns: Backbone.Relational.store._modelScopes[0] };
  } else {
    app = { ns: {} };
    Backbone.Relational.store.addModelScope(app.ns);
  }

  app.ns.GenericEmailDomain = Backbone.RelationalModel.extend({
    defaults: {
      secId: null,
      domain: ''
    },
    idAttribute: 'secId'
  });

  App.reqres.setHandler('genericEmailDomains:model', function (json) {
    var existing = null;
    if (json && json.secId) {
      existing = Backbone.Relational.store.find(app.ns.GenericEmailDomain, json.secId);
    }
    if (existing) {
      existing.set(json);
      return existing;
    }
    return new app.ns.GenericEmailDomain(json);
  });

  var API = {
    getListUrl: function (params) {
      return Settings.url('compuzz2', 'v2/genericemaildomains', params);
    },
    getRowCountUrl: function (params) {
      return Settings.url('compuzz2', 'v2/genericemaildomains/rowCount', params);
    },
    getCollectionUrl: function () {
      return Settings.url('compuzz2', 'v2/genericemaildomains');
    },
    getDeleteUrl: function (secId) {
      return Settings.url('compuzz2', 'v2/genericemaildomains/' + secId);
    }
  };

  App.reqres.setHandler('genericEmailDomains:get-url', function (params) {
    return API.getListUrl(params);
  });

  App.reqres.setHandler('genericEmailDomains:row-count-url', function (params) {
    return API.getRowCountUrl(params);
  });

  App.reqres.setHandler('genericEmailDomains:create', function (json) {
    var defer = $.Deferred();
    $.ajax({
      type: 'POST',
      url: API.getCollectionUrl(),
      contentType: 'application/json',
      data: JSON.stringify(json),
      success: function (data) { defer.resolve(data); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });

  App.reqres.setHandler('genericEmailDomains:delete', function (secId) {
    var defer = $.Deferred();
    $.ajax({
      type: 'DELETE',
      url: API.getDeleteUrl(secId),
      success: function () { defer.resolve(); },
      error: function (xhr) { defer.reject(xhr); }
    });
    return defer.promise();
  });
});

